import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../shared/models/auth.service";
import { ApplicationRouteURL } from "../../shared/config";
import { Router } from "@angular/router";

@Component({
  selector: "wego-creditcard-payment-failure",
  template: require('../views/creditcard-payment-failure.component.html')
})
export class CreditCardPaymentFailureComponent implements OnInit {
  urlDefaultPage: any;

  constructor(public authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
  }
  public onClickOk() {
    let urlBookingOverview = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING
    );
    this.router.navigate([urlBookingOverview]);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/creditcardpaymentpopup/components/creditcard-payment-failure.component.ts